import { inject, Service } from '@angular/core';

import postscribe from 'postscribe';

import { BaasAppState } from '@lvflanders/bar';

type ClassicWidgetsConfig = {
    widgetUrl: string;
    headerWidgetId: string;
    footerWidgetId: string;
};

// NOTE this will be used in disconnected modus (Polaris) or if config is missing
const DEFAULT_WIDGETS_CONFIG: ClassicWidgetsConfig = {
    widgetUrl: '//widgets.vlaanderen.be/widget/live/{widgetId}',
    headerWidgetId: '1ebe22634f1d4cc2b4c5a05de8f78d0c',
    footerWidgetId: '6a87cf7f6e8d443187a349c7ccc0a794'
};

@Service({ autoProvided: false })
export class _BarClassicWidgetsEngine {
    readonly #state = inject(BaasAppState, { optional: true });

    get #config(): ClassicWidgetsConfig {
        return (this.#state?.config?.baasStatic?.classicWidgets as ClassicWidgetsConfig) || DEFAULT_WIDGETS_CONFIG;
    }

    tryMountHeader(element: HTMLElement): boolean {
        // only mount if online (avoid errors SPOT offline)
        if (navigator.onLine) {
            const url = this.#config.widgetUrl.replace('{widgetId}', this.#config.headerWidgetId);
            postscribe(element, `<script src=${url}></script>`);
            return true;
        }
        return false;
    }
    tryMountFooter(element: HTMLElement): boolean {
        // only mount if online (avoid errors SPOT offline)
        if (navigator.onLine) {
            const url = this.#config.widgetUrl.replace('{widgetId}', this.#config.footerWidgetId);
            postscribe(element, `<script src=${url}></script>`);
            return true;
        }
        return false;
    }
}
